import React, { useMemo } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import CategoryTab from './CategoryTab';
import Icn from './Icn';
import Tx from "./Tx";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { api } from '../maps/data.js';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",
    background: isDragging && "lightgreen",
    ...draggableStyle
});

const CategoryTabs = ({ readonly, onAddCategory, selectedCategory, onChange, onEdit, onDelete, setCategories, categories, isLoading, hasProducts }) => {
    const onDragEnd = async (result) => {
        if (!result.destination) {
            return;
        }

        const sourceIndex = result.source.index;
        const destinationIndex = result.destination.index;

        const items = reorder(
            categories,
            sourceIndex,
            destinationIndex
        );

        onChange(items[destinationIndex])
        setCategories(items);

        await api({
            type: 'reorderCategories',
            data: {
                categoryId: categories[sourceIndex]._id,
                newOrder: categories[destinationIndex].order
            }
        });
    }

    const selectedIndex = useMemo(() => {
        const index = categories.findIndex(category => category._id === selectedCategory._id);
        return index < 0 ? categories.length : index;
    }, [categories, selectedCategory]);

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
                {(provided) => (
                    <div ref={provided.innerRef}>
                        {/* Add Category Tab */}
                        {!readonly && (
                            <CategoryTab
                                name={<Tx>category.add</Tx>}
                                icon={<Icn>add</Icn>}
                                onClick={onAddCategory}
                                readonly={true}
                            />
                        )}
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={selectedIndex}
                            aria-label="Vertical tabs"
                            sx={{ borderRight: 1, borderColor: 'divider', height: '100%' }}>

                            {categories.map((category, index) => {
                                const isActiveDelete = selectedIndex >= 1
                                    && !isLoading
                                    && !hasProducts
                                    && selectedCategory._id === category._id;

                                if (readonly) {
                                    return (
                                        <CategoryTab
                                            key={category._id}
                                            name={category.name}
                                            category={category}
                                            onClick={onChange}
                                            onEdit={onEdit}
                                            icon={<Icn>product</Icn>}
                                            onDelete={onDelete}
                                            activeDelete={!readonly && isActiveDelete}
                                            readonly={readonly}
                                        />
                                    )
                                }
                                return (
                                    <Draggable key={category._id} draggableId={category._id} index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}>
                                                <CategoryTab
                                                    name={category.name}
                                                    category={category}
                                                    onClick={onChange}
                                                    onEdit={onEdit}
                                                    icon={<Icn>product</Icn>}
                                                    onDelete={onDelete}
                                                    activeDelete={!readonly && isActiveDelete}
                                                    readonly={readonly}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                )
                            })}
                        </Tabs>
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
}

export default CategoryTabs;